import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { toast } from 'react-toastify';
import Select, { components } from 'react-select'; 
import { isEmpty } from "../../helper/helper.js"

function CourierStatusForm({ props = {  } }) { 
  const [appData, setAppData] = useState({ active: true })
  const [formData, setFormData] = useState({ mCourier: [], mStatus: [] })

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleOnChangeSelect = (option, e) => {
    if (option) {
      if (e.action === "select-option") {
        setAppData(prevState => ({
          ...prevState,
          [e.name]: option.value,
        }))
      } else {
        setAppData(prevState => ({
          ...prevState,
          [e.name]: '',
        }))
      }
    }
  }

  // Custom Option component for the dropdown menu
    const CustomOption = (props) => {
      return (
        <components.Option {...props}>
          <div><span className='fw-bold fs-6 text-red'>{props.data?.label}</span> - <span className='fw-bold fs-6'>{props.data?.status_descr}</span></div>
        </components.Option>
      );
    };

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      courierCode: appData.courierCode,
      statusCode: appData.code,
      statusDescr: appData.descr,
      statusId: appData.statusId,
      active: appData.active,
    }

    /**
     * check / validate data 
     */

    if (isEmpty(appData.courierCode)) {
      toast.error('Courier Code is required')
      return
    }

    if (isEmpty(appData.code) || isEmpty(appData.descr) ) {
      toast.error('Status  Code / Description is required')
      return
    }

    if (isEmpty(appData.statusId) ) {
      toast.error('Mapping to is required')
      return
    }

    if (!props.uid) {
      // New 
      await axios.post(`${window.API_HOST}/v1/courier-status`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          uid: resp.data.id,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        props.uid = resp.data.uid
        toast.success(`Success save Courier status ${appData.courierCode} / ${appData.code}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })
    } else {

      //Update
      await axios.put(`${window.API_HOST}/v1/courier-status/${props.uid}`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        toast.success(`Success Update Courier Status ${appData.courierCode} / ${appData.code}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })

    }


  }

  const retrieveData = async () => {

    await axios.get(`${window.API_HOST}/v1/courier-status/${props.uid}`).then(async (res) => {
      const data = res.data.data

      setAppData(prevState => ({
        ...prevState,
        id: data.status_id,
        code: data.status_code,
        descr: data.status_descr,
        courierCode: data.courier_code,
        statusId: data.status_id,
        active: data.is_active,
        updated_at: data.updated_at,
        updated_by: data.updated_by
      }))

    }).catch(err => {
      toast.error(err.response.data.error)
    })
  }

  async function fetchForm() {
    await axios.get(`${window.API_HOST}/v1/courier-status/form`)
      .then(res => {
        const resp = res.data;
        setFormData(prevState => ({
          ...prevState,
          mCourier: resp.data.courier ?? [],
          mStatus: resp.data.status ?? []
        }))
      }).catch(err => {

      })
  }

  useEffect(() => {

    fetchForm()
    if (props?.uid) {
      retrieveData()
    }

  }, [props.uid]);


  return (
    <div>
      <Panel className='w-600px'>
        <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
          <div className='row'>
            <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} Courier Status</div>
            <div className='col-sm-6 align-items-baseline text-end'>
              <div className=''>
                {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
              </div>

            </div>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-12'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Courier Code</label>
                <div className="col-sm-9">
                  <Select name="courierCode" placeholder={"Courier"} className=''
                    value={(formData?.mCourier ?? []).find(({ value }) => { return value === appData?.courierCode })}
                    onChange={handleOnChangeSelect}
                    options={formData?.mCourier ?? []}  
                    isDisabled={props.uid} 
                  />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Status Code</label>
                <div className="col-sm-9">
                  <input type="text" name="code" value={appData.code ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" disabled={props.uid} />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Status Description</label>
                <div className="col-sm-9">
                  <input type="text" name="descr" value={appData.descr ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Mapping To</label>
                <div className="col-sm-9">
                  <Select name="statusId" placeholder={"Status"} className=''
                    value={(formData?.mStatus ?? []).find(({ value }) => { return value === appData?.statusId })}
                    onChange={handleOnChangeSelect}
                    options={formData?.mStatus ?? []}
                    components={{ Option: CustomOption }}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div> 
              <div className="form-group row mt-3">
                <label className="col-sm-3 col-form-label">Updated By </label>
                <div className="col-sm-9 ">
                  <div className='row'>
                    <div className='col-sm-6'>
                      <input type="text" value={appData.updated_by ?? ''} className="form-control form-control-sm" readOnly disabled />
                    </div>
                    <div className='col-sm-6'>
                      <input type="text" value={appData.updated_at ?? ''} className="form-control form-control-sm" readOnly disabled />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
    </div>

  )


}

export default CourierStatusForm